import React from 'react';
import { IProduct, IVariant, TUserSelection } from '../types/PDP';
import { AlmostGoneBadge } from './ScarcityMessaging/AlmostGoneBadge';
import { handleBadge, hasHiddenInventoryTag, isComingSoon } from 'src/scripts/utils/plp-pdp-shared';
import { SwatchSection } from '../../_shared/types';
import { ADVANCE_ORDER_BADGE_TEXT, ADVANCE_ORDER_TAG, HIDDEN_INVENTORY_TAG } from '../../../utils/constants';
import { isTagPresent } from 'src/scripts/utils/helpers';
import { VARIANT_URGENCY_QUANTITY_CRITERIA } from './ScarcityMessaging/constants';

// Color option helpers
export const ColorSelectionUI = ({
  colorValue,
  isASet,
  swatchSections,
  showBadge = true,
  splitAdvanceOrderBadge = false,
  userSelection,
  variants,
  productDataByColorName,
}: {
  colorValue: string;
  isASet: boolean;
  swatchSections: SwatchSection[];
  showBadge?: boolean;
  splitAdvanceOrderBadge?: boolean;
  userSelection?: TUserSelection;
  variants?: IVariant[];
  productDataByColorName: IProduct['productDataByColorName'];
}) => {
  const tags = productDataByColorName[colorValue]?.tags ?? [];
  const { Size } = userSelection || {};
  const shouldHideInventory = hasHiddenInventoryTag(tags);

  const selectedVariant =
    variants &&
    variants.find((variant) => variant.selectionOptions.Color === colorValue && variant.selectionOptions.Size === Size);
  const needsUrgencyBadge =
    selectedVariant &&
    selectedVariant.quantityAvailable < VARIANT_URGENCY_QUANTITY_CRITERIA &&
    selectedVariant.quantityAvailable > 0 &&
    !shouldHideInventory;

  //we could get the "total" by the field and get the average and compute, but if we pass it by reference we can keep updates... for each color
  const style: React.CSSProperties = {
    border: ['white', 'pristine'].some((value) => colorValue.toLowerCase().includes(value))
      ? '1px solid #BEBDBD'
      : 'none',
  };

  if (swatchSections[0]?.image) {
    // With this linear-gradient approach below, we can't do gradients with images.
    // Instead, if the first section is an image, we show that and ignore the other sections.
    style.backgroundImage = `url("${swatchSections[0].image}")`;
  } else if (swatchSections.length === 1) {
    style.backgroundColor = swatchSections[0]!.color;
  } else if (swatchSections.length === 2) {
    style.backgroundImage = `linear-gradient(${swatchSections[0]!.color} 50%, 50%, ${swatchSections[1]!.color} 100%)`;
  } else if (swatchSections.length >= 3) {
    style.backgroundImage = `linear-gradient(${swatchSections[0]!.color} 33%, 33%, ${
      swatchSections[1]!.color
    } 66%, 66%, ${swatchSections[2]!.color} 100%)`;
  }

  const _isComingSoon = isComingSoon(tags);
  let swatchBadge = _isComingSoon ? 'Coming Soon' : handleBadge(tags);
  if (
    ((splitAdvanceOrderBadge && swatchBadge === ADVANCE_ORDER_BADGE_TEXT) ||
      (!selectedVariant && isTagPresent(tags, ADVANCE_ORDER_TAG))) &&
    !isTagPresent(tags, HIDDEN_INVENTORY_TAG)
  ) {
    // On the PDP, we split the badge so that the text doesn't bleed into the
    // text of the next swatch. Without this hack, the two adjacent PDP swatches
    // with advance order badges look like: PreordePreorder
    swatchBadge = 'Pre-order';
  }
  return (
    <React.Fragment>
      <span title={colorValue} className={`swatch__wrapper ${isASet ? 'swatch__wrapper__color--set' : ''}`}>
        <span className={`swatch ${isASet ? 'swatch--set' : ''}`} style={style}>
          {colorValue}
        </span>
        <span className="swatch-disabled-ui">
          <span className="line" />
        </span>
      </span>
      {showBadge && swatchBadge && (
        <span className="swatchBadge tag-small grey text-center">
          {swatchBadge || (needsUrgencyBadge && <AlmostGoneBadge className="pdp" />)}
        </span>
      )}
    </React.Fragment>
  );
};
